import React from 'react';
import type { BodyIssueEvidenceCandidate, BodyIssueLinkRecord } from '../../types/bodyMapIssue';

interface Props {
  candidates: BodyIssueEvidenceCandidate[];
  links: BodyIssueLinkRecord[];
  linkingId: string | null;
  onLink: (candidate: BodyIssueEvidenceCandidate) => Promise<void> | void;
}

export default function IssueEvidencePanel({ candidates, links, linkingId, onLink }: Props) {
  const linkedDocIds = new Set(links.map((link) => `${link.linkedCollection}:${link.linkedDocId}`));

  return (
    <section className="rounded-3xl border p-6 md:p-8 bg-white" style={{ borderColor: 'var(--melio-border)' }}>
      <p className="text-xs uppercase tracking-[0.2em] mb-3" style={{ color: 'var(--melio-sage)' }}>
        Evidence
      </p>
      <h2 className="text-2xl font-normal mb-5" style={{ fontFamily: "var(--melio-display)", color: 'var(--melio-charcoal)' }}>
        Linked records and uploads
      </h2>

      {links.length > 0 && (
        <div className="space-y-3 mb-6">
          {links.map((link) => (
            <div key={link.id} className="rounded-2xl border px-4 py-3 text-sm" style={{ borderColor: 'var(--melio-border)', backgroundColor: 'var(--b-bone)' }}>
              <div style={{ color: 'var(--melio-charcoal)', fontWeight: 600 }}>{link.label}</div>
              <div style={{ color: 'var(--melio-text-muted)' }}>{link.linkType.replace(/_/g, ' ')}</div>
            </div>
          ))}
        </div>
      )}

      <div className="space-y-3 max-h-[420px] overflow-y-auto">
        {candidates.map((candidate) => {
          const alreadyLinked = linkedDocIds.has(`${candidate.linkedCollection}:${candidate.id}`);
          return (
            <div key={`${candidate.linkedCollection}-${candidate.id}`} className="rounded-2xl border px-4 py-3" style={{ borderColor: 'var(--melio-border)' }}>
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div style={{ color: 'var(--melio-charcoal)', fontWeight: 600 }}>{candidate.label}</div>
                  <div className="text-sm" style={{ color: 'var(--melio-text-muted)' }}>
                    {candidate.linkType.replace(/_/g, ' ')}{candidate.subtitle ? ` • ${candidate.subtitle}` : ''}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => onLink(candidate)}
                  disabled={alreadyLinked || linkingId === candidate.id}
                  className="inline-flex items-center justify-center px-3 py-2 rounded text-sm font-medium transition-opacity hover:opacity-90 disabled:opacity-50"
                  style={{ backgroundColor: alreadyLinked ? '#EFEEE9' : 'var(--melio-charcoal)', color: alreadyLinked ? 'var(--melio-text-muted)' : 'var(--melio-cream)' }}
                >
                  {alreadyLinked ? 'Linked' : linkingId === candidate.id ? 'Linking...' : 'Link'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
